<!--
 * @Desc: 非遗锦盒 从H5进小程序的中转
 * @Author: may.li
 * @Date: 2023-03-17 15:02:48
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-21 12:01:16
-->
<template>
	<div class="page-jinhe">
		<div class="jinhe-top">
			<img :src="ossUrl+'manghestatic/cardh5/zhutu-hezi.png'" alt="" class="zhutu">
		</div>
		<div class="minjinhe-wrap">
			<img :src="ossUrl+'manghestatic/cardh5/bangding-btn.png'" alt="" class="link-btn">
			<wx-open-launch-weapp id="linkBtn" username="gh_13d4df09e5c2" path="pages/index/index">
				<script type="text/wxtag-template">
					<style>.weapp-link-btn {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
					<div class="weapp-link-btn"></div>
				</script>
			</wx-open-launch-weapp>
		</div>
		<div class="fenge-wrap">
			<img :src="ossUrl+'manghestatic/cardh5/fenge-line.png'" alt="" class="fenge-line">
		</div>
		<div class="goods-wrap">
			<div class="wrap-top">
				<div class="wrap-title">五福献礼锦盒</div>
				<img :src="ossUrl+'manghestatic/cardh5/hezi-xianli.png'" alt="" class="wrap-hezi pos-left">
				<img :src="ossUrl+'manghestatic/cardh5/hezi-xianli.png'" alt="" class="wrap-hezi pos-right">
			</div>
			<div class="goods-list">
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/wufu/01.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">《和谐幸福》刻瓷</div>
						<div class="goods-price"><span class="price-unit">¥</span>2600</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/wufu/02.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">古法琉璃车挂</div>
						<div class="goods-price"><span class="price-unit">¥</span>108</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/wufu/03.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">钧瓷杯</div>
						<div class="goods-price"><span class="price-unit">¥</span>588</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/wufu/04.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">狻猊香炉</div>
						<div class="goods-price"><span class="price-unit">¥</span>600</div>
					</div>
				</div>
			</div>
			<wx-open-launch-weapp id="wufu" username="gh_13d4df09e5c2" path="pages/index/index">
				<script type="text/wxtag-template">
					<style>.weapp-link-wufu {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
					<div class="weapp-link-wufu"></div>
				</script>
			</wx-open-launch-weapp>
		</div>
		<div class="goods-wrap lishang">
			<div class="wrap-top">
				<div class="wrap-title">礼尚锦盒</div>
				<img :src="ossUrl+'manghestatic/cardh5/hezi-lishang.png'" alt="" class="wrap-hezi pos-left">
				<img :src="ossUrl+'manghestatic/cardh5/hezi-lishang.png'" alt="" class="wrap-hezi pos-right">
			</div>
			<div class="goods-list">
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/lishang/01.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">白福捧寿如意</div>
						<div class="goods-price"><span class="price-unit">¥</span>36800</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/lishang/02.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">本色双龙头铜壶</div>
						<div class="goods-price"><span class="price-unit">¥</span>860</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/lishang/03.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">年年有余秤香炉</div>
						<div class="goods-price"><span class="price-unit">¥</span>898</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/lishang/04.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">兔多多铜雕摆件</div>
						<div class="goods-price"><span class="price-unit">¥</span>1580</div>
					</div>
				</div>
			</div>
			<wx-open-launch-weapp id="lishang" username="gh_13d4df09e5c2" path="pages/index/index">
				<script type="text/wxtag-template">
					<style>.weapp-link-lishang {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
					<div class="weapp-link-lishang"></div>
				</script>
			</wx-open-launch-weapp>
		</div>
		<div class="goods-wrap feiyi">
			<div class="wrap-top">
				<div class="wrap-title">非遗锦盒</div>
				<img :src="ossUrl+'manghestatic/cardh5/hezi-feiyi.png'" alt="" class="wrap-hezi pos-left">
				<img :src="ossUrl+'manghestatic/cardh5/hezi-feiyi.png'" alt="" class="wrap-hezi pos-right">
			</div>
			<div class="goods-list">
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/feiyi/01.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">高氏皮雕包</div>
						<div class="goods-price"><span class="price-unit">¥</span>2600</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/feiyi/02.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">马尾绣戒指</div>
						<div class="goods-price"><span class="price-unit">¥</span>98</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/feiyi/03.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">剔犀名片夹</div>
						<div class="goods-price"><span class="price-unit">¥</span>600</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/feiyi/04.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">植物染方巾</div>
						<div class="goods-price"><span class="price-unit">¥</span>179</div>
					</div>
				</div>
			</div>
			<wx-open-launch-weapp id="feiyi" username="gh_13d4df09e5c2" path="pages/index/index">
				<script type="text/wxtag-template">
					<style>.weapp-link-feiyi {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
					<div class="weapp-link-feiyi"></div>
				</script>
			</wx-open-launch-weapp>
		</div>
		<div class="goods-wrap huayang">
			<div class="wrap-top">
				<div class="wrap-title">花样非遗锦盒</div>
				<img :src="ossUrl+'manghestatic/cardh5/hezi-huayang.png'" alt="" class="wrap-hezi pos-left">
				<img :src="ossUrl+'manghestatic/cardh5/hezi-huayang.png'" alt="" class="wrap-hezi pos-right">
			</div>
			<div class="goods-list">
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/huayang/01.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">仿点翠材料包</div>
						<div class="goods-price"><span class="price-unit">¥</span>75</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/huayang/02.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">古风绢人材料包</div>
						<div class="goods-price"><span class="price-unit">¥</span>95</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/huayang/03.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">掐丝珐琅材料包</div>
						<div class="goods-price"><span class="price-unit">¥</span>110</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/huayang/04.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">银丝镶嵌材料包</div>
						<div class="goods-price"><span class="price-unit">¥</span>60</div>
					</div>
				</div>
			</div>
			<wx-open-launch-weapp id="huayang" username="gh_13d4df09e5c2" path="pages/index/index">
				<script type="text/wxtag-template">
					<style>.weapp-link-huayang {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
					<div class="weapp-link-huayang"></div>
				</script>
			</wx-open-launch-weapp>
		</div>
		<div class="goods-wrap chengshi">
			<div class="wrap-top">
				<div class="wrap-title">城市有礼锦盒</div>
				<img :src="ossUrl+'manghestatic/cardh5/hezi-chengshi.png'" alt="" class="wrap-hezi pos-left">
				<img :src="ossUrl+'manghestatic/cardh5/hezi-chengshi.png'" alt="" class="wrap-hezi pos-right">
			</div>
			<div class="goods-list">
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/chengshi/01.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">工艺毛猴</div>
						<div class="goods-price"><span class="price-unit">¥</span>120</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/chengshi/02.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">景泰蓝双鱼瓶</div>
						<div class="goods-price"><span class="price-unit">¥</span>17200</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/chengshi/03.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">掐丝珐琅瓷盘</div>
						<div class="goods-price"><span class="price-unit">¥</span>1400</div>
					</div>
				</div>
				<div class="goods-item">
					<div class="item-top">
						<img :src="ossUrl+'manghestatic/cardh5/chengshi/04.png'" alt="" class="goods-tu">
					</div>
					<div class="item-info">
						<div class="goods-title">珠花凤冠中国结</div>
						<div class="goods-price"><span class="price-unit">¥</span>180</div>
					</div>
				</div>
			</div>
			<wx-open-launch-weapp id="chengshi" username="gh_13d4df09e5c2" path="pages/index/index">
				<script type="text/wxtag-template">
					<style>.weapp-link-chengshi {position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0); }</style>
					<div class="weapp-link-chengshi"></div>
				</script>
			</wx-open-launch-weapp>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			memberUrl: this.$publicData.domain+'/jinhe',
			publicPath: process.env.BASE_URL,
			ossUrl: this.$publicData.uploadImage
		}
	},
	created(){
		let that = this;
		this.token = this.$store.getters.token;
		if(this.token){
			let type = this.$route.query.type;
			let number = this.$route.query.number;
			if(type && number){
				// 验证卡是否可用
				that.verfyCard(type,number);
			}
		}else{
			// 进入登录流程
			localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
			this.$router.push({
				path: '/login'
			})
		}
	},
	methods: {
		/**
		 * @name: 验证卡号是否可用
		 * @param {*} type
		 * @param {*} number
		 * @return {*}
		 * @desc: 锦盒绑充值卡
		 */		
		verfyCard(type,number){
			let that = this;
			let params = {
				token: this.token,
				type: type,
				number: number
			}
			this.$api.jinhe.verfyCard(params).then(res=>{
				if(res.code == 200){
					let cardId = res.result;
					that.bindCard(cardId);
				}else{
					window.history.replaceState(null, null,that.memberUrl);
				}
			})
		},
		/**
		 * @name: 绑充值卡
		 * @param {*} cardId
		 * @return {*}
		 * @desc: 锦盒绑充值卡
		 */		
		bindCard(cardId){
			let that = this;
			let params = {
				token: this.token,
				card_id: cardId
			};
			this.$api.jinhe.bindCard(params).then(res=>{
				if(res.code == 200){
					window.history.replaceState(null, null,that.memberUrl);
				}else{
					window.history.replaceState(null, null,that.memberUrl);
				}
			})
		}
	},
}
</script>
<style scoped>
	.minjinhe-wrap{
		position: relative;
	}
	.minjinhe-wrap #linkBtn{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.goods-wrap{
		position: relative;
	}
	.goods-wrap #wufu,.goods-wrap #lishang,.goods-wrap #feiyi,.goods-wrap #huayang,.goods-wrap #chengshi{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
</style>